/* Zojee: I-Got-You Cream landing page interactions */
(() => {
  if (window.__zlpInit) return; window.__zlpInit = true;
  const CFG = window.ZLP || {};
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* ---------- Staggered reveals ---------- */
  const revealEls = $$('.reveal, .flyin');
  if (reduce || !('IntersectionObserver' in window)) {
    revealEls.forEach(el => el.classList.add('is-in'));
  } else {
    const groups = new Map();
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (!e.isIntersecting) return;
        const el = e.target;
        const parent = el.parentElement;
        const n = (groups.get(parent) || 0);
        groups.set(parent, n + 1);
        el.style.transitionDelay = `${Math.min(n, 8) * 70}ms`;
        el.classList.add('is-in');
        io.unobserve(el);
        setTimeout(() => groups.set(parent, 0), 900);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    revealEls.forEach(el => io.observe(el));
    // tilted fly-in angle for review cards
    $$('.review.flyin').forEach((el, i) => el.style.setProperty('--rot', `${(i % 2 ? 1 : -1) * 1.5}deg`));
  }

  /* ---------- Signature: pinned product + chapter scrub ---------- */
  const worlds = $('.worlds');
  const chapters = worlds ? $$('.chapter', worlds) : [];
  const dots = worlds ? $$('.chapter-dots i', worlds) : [];
  const product = worlds && $('.worlds__product', worlds);
  const orb = worlds && $('.worlds__orb', worlds);
  const desktop = () => window.matchMedia('(min-width: 901px)').matches;
  let current = 0;

  function setChapter(i) {
    current = i;
    chapters.forEach((c, k) => c.classList.toggle('is-active', k === i));
    dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
    worlds.style.setProperty('--wbg', chapters[i].dataset.bg);
    if (!reduce && product && orb) {
      const rot = [-4, 3, -2, 4][i % 4];
      product.style.transform = `rotate(${rot}deg) translateY(${i % 2 ? -8 : 0}px)`;
      orb.style.transform = `scale(${1 + i * 0.08}) translate(${i * 6}px, ${-i * 8}px)`;
    }
  }

  function onScroll() {
    if (!desktop()) return;
    const r = worlds.getBoundingClientRect();
    const total = worlds.offsetHeight - window.innerHeight;
    const progress = Math.min(1, Math.max(0, -r.top / total));
    const i = Math.min(chapters.length - 1, Math.floor(progress * chapters.length));
    setChapter(i);
  }

  if (worlds && chapters.length) {
    // Mode switching: pinned scrub on desktop, stacked list on mobile. Re-evaluated on every
    // viewport change so a window that loads narrow and grows never shows all chapters at once.
    const mq = window.matchMedia('(min-width: 901px)');
    let mio = null;
    const enterDesktop = () => {
      if (mio) { mio.disconnect(); mio = null; }
      worlds.classList.add('is-scrub');
      chapters.forEach((c, k) => c.classList.toggle('is-active', k === current));
      dots.forEach((d, k) => d.classList.toggle('is-active', k === current));
      onScroll();
    };
    const enterMobile = () => {
      worlds.classList.remove('is-scrub');
      chapters.forEach(c => c.classList.add('is-active'));
      dots.forEach(d => d.classList.remove('is-active'));
      if (product) product.style.transform = '';
      if (orb) orb.style.transform = '';
      if ('IntersectionObserver' in window && !mio) {
        mio = new IntersectionObserver(entries => {
          entries.forEach(e => { if (e.isIntersecting) worlds.style.setProperty('--wbg', e.target.dataset.bg); });
        }, { threshold: 0.6 });
        chapters.forEach(c => mio.observe(c));
      }
    };
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { onScroll(); ticking = false; });
    }, { passive: true });
    const applyMode = () => (mq.matches ? enterDesktop() : enterMobile());
    if (mq.addEventListener) mq.addEventListener('change', applyMode); else mq.addListener(applyMode);
    window.addEventListener('resize', () => { if (mq.matches) onScroll(); }, { passive: true });
    applyMode();
  }
  dots.forEach((d, i) => d.addEventListener('click', () => {
    const total = worlds.offsetHeight - window.innerHeight;
    const top = worlds.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({ top: top + total * (i / chapters.length) + 10, behavior: reduce ? 'auto' : 'smooth' });
  }));

  /* ---------- Tilt cards ---------- */
  if (!reduce && window.matchMedia('(hover: hover)').matches) {
    $$('.tilt').forEach(card => {
      card.addEventListener('pointermove', e => {
        const b = card.getBoundingClientRect();
        const x = (e.clientX - b.left) / b.width - 0.5;
        const y = (e.clientY - b.top) / b.height - 0.5;
        card.style.transform = `rotateX(${-y * 8}deg) rotateY(${x * 8}deg) translateY(-4px)`;
      });
      card.addEventListener('pointerleave', () => { card.style.transform = ''; });
    });
  }

  /* ---------- Count-up review stats ---------- */
  const stats = $$('[data-count]');
  if (stats.length) {
    const run = el => {
      const target = parseFloat(el.dataset.count);
      const dec = parseInt(el.dataset.decimals || '0', 10);
      const suffix = el.dataset.suffix || '';
      if (reduce) { el.textContent = target.toFixed(dec) + suffix; return; }
      const t0 = performance.now();
      const dur = 1100;
      const step = now => {
        const p = Math.min(1, (now - t0) / dur);
        const eased = 1 - Math.pow(1 - p, 3);
        el.textContent = (target * eased).toFixed(dec) + suffix;
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    if ('IntersectionObserver' in window) {
      const sio = new IntersectionObserver(entries => {
        entries.forEach(e => { if (e.isIntersecting) { run(e.target); sio.unobserve(e.target); } });
      }, { threshold: 0.5 });
      stats.forEach(s => sio.observe(s));
    } else stats.forEach(run);
  }

  /* ---------- Bundle builder (Shopify cart) ---------- */
  const CREAM = { id: String(CFG.creamId || '52375275471141'), name: CFG.creamName || 'I-Got-You Cream', price: Number(CFG.creamPrice || 55) };
  const DUO = { id: String(CFG.duoId || '52396283429157'), name: CFG.duoName || 'Signature Care Duo (Wash + Cream)', price: Number(CFG.duoPrice || 99) };
  const FREE_SHIP = Number(CFG.freeShip || 70);
  const addWash = $('#add-wash');
  const addKit = $('#add-kit');
  const lines = $('#receipt-lines');
  const totalEl = $('#receipt-total');
  const saveEl = $('#receipt-save');
  const fill = $('#ship-fill');
  const shipMsg = $('#ship-msg');
  const checkout = $('#checkout-btn');
  const money = n => `$${n.toFixed(2)}`;
  let cartItems = [{ id: CREAM.id, quantity: 1 }];

  function updateBuilder() {
    if (!checkout || !lines) return;
    const wash = addWash && addWash.checked;
    const kit = addKit && addKit.checked;
    const kitPrice = addKit ? Number(addKit.dataset.price || 15) : 0;
    const kitName = addKit ? (addKit.dataset.name || 'Discovery Kit') : '';
    const items = [];
    let total = 0;
    cartItems = [];
    if (wash) {
      items.push({ name: DUO.name, price: DUO.price }); total += DUO.price;
      cartItems.push({ id: DUO.id, quantity: 1 });
      if (saveEl && !saveEl.dataset.always) saveEl.hidden = false;
    } else {
      items.push({ name: CREAM.name, price: CREAM.price }); total += CREAM.price;
      cartItems.push({ id: CREAM.id, quantity: 1 });
      if (saveEl && !saveEl.dataset.always) saveEl.hidden = true;
    }
    if (kit) { items.push({ name: kitName, price: kitPrice }); total += kitPrice; cartItems.push({ id: String(addKit.dataset.id), quantity: 1 }); }
    lines.innerHTML = items.map(i => `<li><span>${i.name}</span><span>${money(i.price)}</span></li>`).join('');
    if (totalEl) { totalEl.textContent = money(total); totalEl.classList.add('tick'); setTimeout(() => totalEl.classList.remove('tick'), 200); }
    const p = Math.min(1, total / FREE_SHIP);
    if (fill) { fill.style.transform = `scaleX(${p})`; fill.classList.toggle('is-free', p >= 1); }
    if (shipMsg) shipMsg.innerHTML = p >= 1
      ? `<strong>${CFG.freeShipUnlocked || 'Free shipping unlocked'}</strong> · ${CFG.freeShipRegion || 'Australia wide'}`
      : `${CFG.addMore || 'Add'} <strong>${money(FREE_SHIP - total)}</strong> ${CFG.moreToUnlock || 'more to unlock free shipping'}`;
    const label = `${CFG.addLabel || 'Add to cart'} · ${money(total)}`;
    const span = checkout.querySelector('span');
    if (span) { span.textContent = label; span.dataset.label = label; }
  }
  [addWash, addKit].forEach(cb => cb && cb.addEventListener('change', updateBuilder));
  updateBuilder();

  if (checkout) checkout.addEventListener('click', e => {
    e.preventDefault();
    checkout.disabled = true;
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: cartItems })
    }).then(r => { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(() => { window.location.href = root + 'cart'; })
      .catch(() => {
        // Fallback: permalink adds the same items
        window.location.href = root + 'cart/' + cartItems.map(i => `${i.id}:${i.quantity}`).join(',');
      });
  });

  /* ---------- FAQ accordion (grid-template-rows animation) ---------- */
  $$('.qa').forEach(d => {
    const summary = $('summary', d);
    if (d.open) d.classList.add('is-open');
    summary.addEventListener('click', e => {
      e.preventDefault();
      if (d.open) {
        d.classList.remove('is-open');
        const body = $('.qa__body', d);
        const done = () => { d.open = false; body.removeEventListener('transitionend', done); };
        if (reduce) done(); else body.addEventListener('transitionend', done);
        setTimeout(() => { if (!d.classList.contains('is-open')) d.open = false; }, 500);
      } else {
        d.open = true;
        requestAnimationFrame(() => d.classList.add('is-open'));
      }
    });
  });

  /* ---------- Sticky dock: after hero, hidden over offer + footer ---------- */
  const dock = $('#dock');
  const hero = $('.zlp .hero');
  const offer = $('.zlp .offer');
  const footer = $('footer, .shopify-section-group-footer-group');
  const closer = $('.zlp .closer');
  function updateDock() {
    if (!dock) return;
    const y = window.scrollY;
    const heroEnd = hero ? (hero.getBoundingClientRect().top + window.scrollY + hero.offsetHeight) : 600;
    const inZone = el => { if (!el) return false; const r = el.getBoundingClientRect(); return r.top < window.innerHeight * 0.85 && r.bottom > window.innerHeight * 0.4; };
    const show = y > heroEnd && !inZone(offer) && !inZone(footer) && !inZone(closer);
    dock.classList.toggle('is-visible', show);
    dock.setAttribute('aria-hidden', show ? 'false' : 'true');
  }
  window.addEventListener('scroll', updateDock, { passive: true });
  updateDock();

  /* ---------- Email capture: gentle success state ---------- */
  const form = $('.zlp .capture');
  if (form) form.addEventListener('submit', e => {
    const emailEl = $('input[type=email]', form);
    const email = emailEl ? emailEl.value.trim() : '';
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      e.preventDefault();
      if (emailEl) emailEl.focus();
      form.classList.add('is-error');
      setTimeout(() => form.classList.remove('is-error'), 800);
      return;
    }
    form.classList.add('is-done');
    const btn = $('button span', form);
    if (btn) { btn.textContent = CFG.thanks || 'Thank you'; btn.dataset.label = CFG.thanks || 'Thank you'; }
  });

  /* ---------- Make sure hero video plays ---------- */
  $$('.zlp video[autoplay]').forEach(v => { v.muted = true; const p = v.play(); if (p && p.catch) p.catch(() => {}); });
})();
